import { appDefinitions, BU, PILLAR } from './app-definitions';

export const name = 'landingContent';
export default function landingContent(
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const directive = {
    restrict: 'EA',
    scope: {
      bu: '=',
      locale: '=',
    },
    template: require('./landing-content.jade'),
    link: landingContentLink,
    controller: landingContentController,
    controllerAs: 'vm',
    bindToController: true,
  };

  return directive;


  //////////////////////
  // Private functions

  function landingContentLink(scope, element, attrs) {
  }

  /** @ngInject */
  function landingContentController(
    rnClient,
    rnLocale,
    rnLocalStorage,
    $gzEULA,
    $gzAnalytics,
    $translate,
    $rootScope,
    $window,
    $timeout
  ) {
    // Constants
    const HOST_WHITE_LIST = ['printos-dev.test','daily.gsbprint.net'];
    // Variables
    let currentLocale;
    let isIconUX = false;

    // View Model
    let vm = this;
    vm.loading = true;
    vm.signInData = {};
    vm.categories = [
      {
        id: 'optimize',
        icon: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
        displayKey: 'register.register.Pillar_Optimize_Section',
        apps: [],
        filteredAppCount: 0,
      },
      {
        id: 'automate',
        icon: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
        displayKey: 'register.register.Pillar_Automate_Section',
        apps: [],
        filteredAppCount: 0,
      },
      {
        id: 'grow',
        icon: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
        displayKey: 'register.register.Pillar_Grow_Section',
        apps: [],
        filteredAppCount: 0,
      },
    ];

    vm.localeChanged = localeChanged;
    vm.openTerms = openTerms;
    vm.scroll = scroll;
    vm.selectBU = selectBU;
    vm.linkClicked = linkClicked;
    vm.closeApp = closeApp;

    activate();
    return;


    ///////////////////////////////////////////////////////////
    // Activate
    function activate() {
      return rnClient.getConfig().then(cc => {
        // isIconUX = cc.features.includes('ux-app-icons');
        vm.supportURL = '#/support?fromState=signin&expanded=false';
        if (vm.bu) {
          vm.supportURL += `&bu=${vm.bu}`;
        }

        if (HOST_WHITE_LIST.includes($window.location.host)) {
          vm.isAppUX = true;
        }

        initApplications();
        filterApplications();

        $timeout(() => {
          let myContainer = $window.document.getElementById('parallax-container');
          if (myContainer) {
            vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
            vm.atTop = myContainer.scrollTop === 0;
            updateWelcomePositioning();
            myContainer.addEventListener('scroll', event => {
              $rootScope.$applyAsync(updateWelcomePositioning);
            });
          }
        },2000);

        $window.addEventListener('resize', event => {
          let myContainer = $window.document.getElementById('parallax-container');
          if (myContainer) {
            $rootScope.$applyAsync(() => {
              vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
              vm.atTop = myContainer.scrollTop === 0;
              updateWelcomePositioning();
            });
          }
        });
      })
        .finally(() => {
        vm.loading = false;
      });
    }

    function initApplications() {
      appDefinitions.forEach(def => {
        def.name = $translate.instant(`register.register.${def.id}_Name`);
        def.desc = $translate.instant(`register.register.${def.id}_Desc`);
        let iconDir = isIconUX ? 'icons2' : 'icons';
        def.icon = `https://cdn.printos.com/images/application/${iconDir}/${def.appId}.svg`;
        def.show = true;
      });

      vm.categories[0].apps = appDefinitions.filter(def => {
        return def.pillar === PILLAR.Optimize;
      });

      vm.categories[1].apps = appDefinitions.filter(def => {
        return def.pillar === PILLAR.Automate;
      });

      vm.categories[2].apps = appDefinitions.filter(def => {
        return def.pillar === PILLAR.Grow;
      });

    }

    function updateWelcomePositioning() {
      let myContainer = $window.document.getElementById('parallax-container');
      let test = $window.document.getElementById('caption-1');
      let tRect = test.getBoundingClientRect();
      let pRect = test.parentElement.getBoundingClientRect();
      let heightOnScreen = pRect.height - myContainer.scrollTop;
      let bottomWhiteSpace = (heightOnScreen - tRect.height) * 0.6;
      test.style.bottom = bottomWhiteSpace < 64 ? '64px' : bottomWhiteSpace + 'px';
      vm.atTop = myContainer.scrollTop === 0;
    }


    ///////////////////////////////////////////////////////////
    // View Model
    function localeChanged() {
      currentLocale = vm.signInData.locale;
      vm.locale = currentLocale;
      $translate.use(currentLocale.value);
      rnLocale.setLocalePreference(currentLocale);

      // Temporarily commenting this out until we figure out a path forward with the following issue. This
      // particular event ('locale dropdown - selected') is the #1 reported event in the 'register' category
      // due to the fact that this function is called by Material Design during each page refresh, sign-in,
      // and sign-out. It does not reflect actual usage by the user. However, we would like to know how often
      // this is used.
      //
      //$gzAnalytics.eventSelect('locale dropdown', {label: currentLocale.value});
    }

    function openTerms() {
      $gzEULA.show();
    }

    function scroll(event) {
      event.preventDefault();
      let myContainer = $window.document.getElementById('parallax-container');
      if (vm.atTop) {
        $gzAnalytics.event('Click: scroll Down button', {category:'landing-page'});
        myContainer.scrollTo({top: myContainer.scrollHeight, behavior: 'smooth'});
      }
      else {
        $gzAnalytics.event('Click: scroll Up button', {category:'landing-page'});
        myContainer.scrollTo({top: 0, behavior: 'smooth'});
      }
    }

    function selectBU(bu) {
      vm.bu = bu;
      filterApplications();
    }

    function closeApp(app) {
      $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', {detail: { playerId: 'gz-carousel' }} ));
    }

    function linkClicked(app) {
      if (app.learn.link) {
        $window.open(app.learn.link, '_blank');
      }
    }

    ///////////////////////////////////////////////////////////
    // Helpers
    function filterApplications() {
      vm.categories[0].filteredAppCount = 0;
      vm.categories[1].filteredAppCount = 0;
      vm.categories[2].filteredAppCount = 0;
      vm.categories[0].apps.forEach(def => {
        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
        if (def.show) {
          vm.categories[0].filteredAppCount++;
        }
      });
      vm.categories[1].apps.forEach(def => {
        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
        if (def.show) {
          vm.categories[1].filteredAppCount++;
        }
      });
      vm.categories[2].apps.forEach(def => {
        def.show = vm.bu ? def.businessUnits.includes(vm.bu) : true;
        if (def.show) {
          vm.categories[2].filteredAppCount++;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./components/landing-content/landing-content.directive.js